// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9081) return "static/css/9081.9fd1728a3dadea9c06a0.css";
	if (chunkId === 6204) return "static/css/receiver.4b96a9ee8f8c236b67ab.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6559":"b2e5d3c087a7fdcef4f6","6594":"ebdb3886dc2743933f80","6918":"ebdb3886dc2743933f80","7076":"ebdb3886dc2743933f80"}[chunkId] + ".chunk.css";
};